export default "__VITE_ASSET__SH_GJzQo__"